window.Aerotech = window.Aerotech || {};

window.Aerotech.FeedbackForm = (function ($, Behaviors) {
    "use strict";

    /**
     * Feedback form handler that grabs the search parameter from the page and
     * propagates it to a connected Pardot form.
     */
    function FeedbackForm() {
        var url;

        Behaviors.init(FeedbackForm, this, arguments);

        if (window.location.hash && window.location.hash.startsWith("#!")) {
            url = this.$elem.attr("src");
            this.$elem.attr("src", url + window.location.hash);
        }
    }

    Behaviors.inherit(FeedbackForm, Behaviors.Behavior);

    FeedbackForm.QUERY = "[data-aerotech-feedbackform]";

    Behaviors.register_behavior(FeedbackForm);

    return FeedbackForm;
}(window.jQuery, window.Behaviors));